import { render, staticRenderFns } from "./general-information.vue?vue&type=template&id=5d46f11a&scoped=true"
import script from "./general-information.vue?vue&type=script&lang=js"
export * from "./general-information.vue?vue&type=script&lang=js"
import style1 from "./general-information.vue?vue&type=style&index=1&id=5d46f11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46f11a",
  null
  
)

export default component.exports